__turbopack_context__.v({
  "Container": "_483m6q_Container",
  "Description": "_483m6q_Description",
  "Image": "_483m6q_Image",
  "Root": "_483m6q_Root",
  "Root--Border": "_483m6q_Root--Border",
  "Root--Large": "_483m6q_Root--Large",
  "Root--NoImage": "_483m6q_Root--NoImage",
  "Root--Small": "_483m6q_Root--Small",
  "Root--Square": "_483m6q_Root--Square",
  "Text": "_483m6q_Text",
  "TextNoIcon": "_483m6q_TextNoIcon",
  "skeleton-loading": "_483m6q_skeleton-loading",
});
